import React from "react";
import { Container, ImageList, ImageListItem } from "@material-ui/core";
import { Banner, ImageWrapper } from "../base";
export var LinkinBioImageList = function (_a) {
    var articles = _a.articles, banner = _a.banner, imageWrapper = _a.imageWrapper, bannerWrapper = _a.bannerWrapper;
    return (React.createElement(Container, { maxWidth: "md", style: { overflow: "hidden" } },
        React.createElement(ImageList, { cols: 3, gap: 2, style: { overflow: "hidden", marginTop: "1em" } },
            (banner === null || banner === void 0 ? void 0 : banner.bannerUrl) && React.createElement(Banner, { imageWrapper: bannerWrapper, banner: banner }),
            articles.map(function (article) {
                var serviceMessageId = article.serviceMessageId;
                return (React.createElement(ImageListItem, { style: { width: "33%", height: "auto", aspectRatio: "1" }, key: serviceMessageId, "data-testid": "lib-image-item-wrapper-".concat(serviceMessageId) },
                    React.createElement(ImageWrapper, { article: article, dataTestId: "lib-image-item-".concat(serviceMessageId), wrapperFunc: imageWrapper })));
            }))));
};
